"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddressUpsertDto = instanceOfAddressUpsertDto;
exports.AddressUpsertDtoFromJSON = AddressUpsertDtoFromJSON;
exports.AddressUpsertDtoFromJSONTyped = AddressUpsertDtoFromJSONTyped;
exports.AddressUpsertDtoToJSON = AddressUpsertDtoToJSON;
exports.AddressUpsertDtoToJSONTyped = AddressUpsertDtoToJSONTyped;
const State_1 = require("./State");
/**
 * Check if a given object implements the AddressUpsertDto interface.
 */
function instanceOfAddressUpsertDto(value) {
    if (!('line1' in value) || value['line1'] === undefined)
        return false;
    if (!('city' in value) || value['city'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined)
        return false;
    if (!('zealWorkLocationId' in value) || value['zealWorkLocationId'] === undefined)
        return false;
    return true;
}
function AddressUpsertDtoFromJSON(json) {
    return AddressUpsertDtoFromJSONTyped(json, false);
}
function AddressUpsertDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'line1': json['line1'],
        'city': json['city'],
        'state': (0, State_1.StateFromJSON)(json['state']),
        'postalCode': json['postalCode'],
        'zealWorkLocationId': json['zealWorkLocationId'],
        'id': json['id'] == null ? undefined : json['id'],
        'line2': json['line2'] == null ? undefined : json['line2'],
    };
}
function AddressUpsertDtoToJSON(json) {
    return AddressUpsertDtoToJSONTyped(json, false);
}
function AddressUpsertDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'line1': value['line1'],
        'city': value['city'],
        'state': (0, State_1.StateToJSON)(value['state']),
        'postalCode': value['postalCode'],
        'zealWorkLocationId': value['zealWorkLocationId'],
        'id': value['id'],
        'line2': value['line2'],
    };
}
//# sourceMappingURL=AddressUpsertDto.js.map